
  <p class="mb-8"><b>Terms and conditions for using Face ID</b></p>

  <p class="text-body-sm">Content</p>

<div class="mb-16" style="display: inline-flex;">
    <button ds-button
        type="submit"
        role="button"
        class="w-100 mb-16 ml-48"
        (click)="onAcceptTermsAndConditionsClick()"
        title="Accept">
        <span>Accept</span>
</button>

<button ds-button
       variant="secondary"
        type="submit"
        role="button"
        class="w-100 mb-16 ml-24"
        (click)="onDeclineTermsAndConditionsClick()"
        title="Decline">
        <span>Decline</span>
</button>
</div>